import React from "react";

export default function Layout({
  component: Component,
}) {
  return <Component />;
}
